var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleTemperatureWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_temperature_warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(22025.443 23510.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-temperature-low",
    "data-name": "Icon awesome-temperature-low",
    d: "M10.719,4.69a4.69,4.69,0,0,0-9.379,0v6.972a6.019,6.019,0,1,0,10.719,3.748,5.976,5.976,0,0,0-1.34-3.748Z",
    transform: "translate(-22019.473 -23508.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M0,11.349A3.306,3.306,0,0,1,2.2,8.232V1.1a1.1,1.1,0,1,1,2.2,0v7.13A3.306,3.306,0,1,1,0,11.349Z",
    transform: "translate(-22016.748 -23504.621)",
    fill: "#e88f25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleTemperatureWarning);
export default __webpack_public_path__ + "static/media/ic_tele_temperature_warning.99522eea98b563888d06d84562273f66.svg";
export { ForwardRef as ReactComponent };